<template>
  <div id="schjMap" class="schjMap">
    <img class="location" src="~images/schj/location.png" @click="location" />
    <img
      src="@/assets/images/schj/tozb.png"
      @click="toZb"
      alt=""
      class="btm-zb"
    />
    <!-- <left-side>
      <div class="boxContent">
        <el-tabs type="border-card">
          <el-tab-pane :label="main1Name">
            <div ref="main2" class="ec-main" v-show="!noChart1"></div>
            <div class="ec-main noChart" v-show="noChart1">
              暂无数据
            </div>
          </el-tab-pane>
          <el-tab-pane :label="main2Name">
            <div class="ec-main" ref="main1" v-show="!noChart2"></div>
            <div class="ec-main noChart" v-show="noChart2">
              暂无数据
            </div>
          </el-tab-pane>
        </el-tabs>
      </div> 
    </left-side>-->
  </div>
</template>
<script>
const debounce = require("lodash.debounce");
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
import "@/assets/css/schj.css";
import {
  findDataSaleBydataKindIdAndYearAndProvinceCodeForMap,
  findDataSaleByXSID,
  // findDataPriceBydataKindIdAndYearAndProvinceCode,
  findDataSaleBydataKindIdAndYearAndProvinceCode,
  // findDataPriceBydataKindIdAndYear
  findDataSaleBydataKindIdAndYear,
  getDataBrandDataByCode,
} from "@/api/schj";
import "leaflet-echarts/dist/leaflet-echarts";
import "leaflet-echarts/lib/echarts.source";
import "leaflet.heat";
import { initialize } from "@/util/application";
export default {
  name: "schj",
  data() {
    return {
      ismmsMap: false, // 是否显示茂名市map
      dw: "吨",
      schjMap: null,
      echarts2: null,
      echarts1: null,
      popup: null,
      clatlng: null,
      main2Name: "全国销售排行",
      main1Name: "省内销售排行",
      overlay: null,
      noChart1: false,
      noChart2: false,
      firstLoad: true,
      brandKind: {}, //品牌种类
      brandList: [], //品牌列表
    };
  },
  computed: {
    curcode() {
      return this.$store.state.schj.code;
    },
    cName() {
      return this.$store.state.schj.cname;
    },
    cMonth() {
      return this.$store.state.schj.cmonth;
    },
    dataKindId() {
      return this.$store.state.schj.dataKindId;
    },
  },
  watch: {
    cName() {
      if (!this.firstLoad) {
        this.reLoadFxl();
      }
    },
    cMonth() {
      if (!this.firstLoad) {
        this.reLoadFxl();
      }
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.chartResize);
    this.$bus.$off("ppjsclick");
  },
  mounted: function() {
    // this.echarts1 = this.$echarts.init(this.$refs.main1);
    // this.echarts2 = this.$echarts.init(this.$refs.main2);
    this.init();
    window.addEventListener("resize", this.chartResize);
    this.$bus.$on("ppjsclick", (val) => {
      console.log("pp val", val);
      this.brandKind = val;
      if (!this.ismmsMap) {
        this.tomms();
      } else {
        // todo 更新图层
        console.log("更新图层");
        this.tomms();
      }
    });
  },
  methods: {
    toZb() {
      this.$store.dispatch("schj/setCode", "zb");
    },
    init() {
      this.initMap();
      setTimeout(() => {
        this.loadFxl();
      }, 100);
    },
    initMap() {
      let CRS_china_3857 = new L.Proj.CRS(
        "EPSG:3857",
        "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378137 +b=6378137 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
        {
          resolutions: [
            156543.03392800014,
            78271.51696399994,
            39135.75848200009,
            19567.87924099992,
            9783.93962049996,
            4891.96981024998,
            2445.98490512499,
            1222.992452562495,
            611.4962262813797,
            305.74811314055756,
            152.87405657041106,
            76.43702828507324,
            38.21851414253662,
            19.10925707126831,
            9.554628535634155,
            4.77731426794937,
            2.388657133974685,
            1.1943285668550503,
            0.5971642835598172,
            0.29858214164761665,
          ],
          origin: [-2.0037508342787e7, 2.0037508342787e7],
        }
      );
      if (this.schjMap) {
        this.schjMap.off();
        this.schjMap.remove();
      }
      this.schjMap = L.map("schjMap", {
        src: CRS_china_3857,
        minZoom: 4,
        maxZoom: 5,
        zoomControl: false,
        scrollWheelZoom: false,
        keyboard: false,
        doubleClickZoom: false,
      }).on("click", (ev) => {
        this.clatlng = ev.latlng;
      });
      window.schjmap = this.schjMap;
      let tileMapLayer = esri.tiledMapLayer({
        url: this.$config.schjLxMap,
      });
      tileMapLayer.addTo(this.schjMap);
      this.ismmsMap = false;
      this.location();
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        $(".leaflet-control-attribution").empty();
      }, 300);
    },
    clearLayer(reloadMap = true) {
      // eslint-disable-next-line no-undef
      if ($(".leaflet-overlay-pane div:nth-child(1)").length >= 2) {
        if (this.overlay != null) {
          // this.myChart0.un("click");
          this.overlay._ec.clear();
          this.myChart0.clear();
          this.overlay = null;
        }
        // eslint-disable-next-line no-undef
        $(".leaflet-overlay-pane div:nth-child(1)")[0].remove(); //去除迁徙图
      } else {
        console.log(
          '$(".leaflet-overlay-pane div:nth-child(1)")',
          // eslint-disable-next-line no-undef
          $(".leaflet-overlay-pane div:nth-child(1)")
        );
        // $(".leaflet-overlay-pane div:nth-child(1)")[0].parentElement.remove();
      }
      if (this.heatMap) {
        this.schjMap.removeLayer(this.heatMap);
        this.heatMap = null;
      }
      if (reloadMap) {
        this.schjMap.eachLayer(function(layer) {
          layer.remove();
        });
      }
    },
    goMmsMap() {
      // 切到小图中心点
      let tileMapUrl =
        window.__config.VUE_APP_MAP_URL +
        "/rest/services/440900/mm_as_01/MapServer";
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=GRS80 +no_defs",
        {
          resolutions: [
            0.0019035688046642242,
            0.00118973050291514,
            5.9486525145757e-4,
            2.97432625728785e-4,
          ],
          origin: [-400.0, 399.9999999999998],
        }
      );
      if (this.schjMap) {
        this.schjMap.off();
        this.schjMap.remove();
      }
      this.schjMap = L.map("schjMap", {
        crs: CRS_4490,
        minZoom: 0,
        maxZoom: 3,
        zoomControl: false,
      });

      // resetView ?
      // this.schjMap.options.crs = CRS_4326;
      // this.schjMap.setMinZoom(1);
      let tileMapLayer = esri.tiledMapLayer({
        url: tileMapUrl,
      });
      // map.addLayer(tileMapLayer);
      tileMapLayer.addTo(this.schjMap);
      this.brandLoad();
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        $(".leaflet-control-attribution").empty();
      }, 300);
    },
    //加载品牌数据
    brandLoad() {
      getDataBrandDataByCode({ code: this.brandKind.code }).then((res) => {
        console.log("BrandData", res);
        this.brandList = res.data;
        this.brandPointLoad();
      });
    },

    //品牌点数据加载
    brandPointLoad() {
      // this.jdArr = [];
      if (this.brandGroup) {
        this.schjMap.removeLayer(this.brandGroup);
      }
      this.brandGroup = new L.layerGroup();
      this.brandList.map((it) => {
        if (it.latitude_) {
          // let pointUrl = require("images/map/bluexx.png");

          var myIcons;
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><div class='zhu-div-box'><div class='nopx-point-y'></div><div class='zhu-div-text zhu-div-name zhu-yellow hide yellow' ><p class='zhus-div-name'>" +
              it.name +
              "</p><p class='zhus-div-info'>" +
              it.type +
              "</p></div></div></div>",
            className: "zhu-div-icon",
          });
          // myIcons = L.divIcon({
          //   html:
          //     "<div class='indicator-box sLine ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
          //     it.tc_pic +
          //     "' src='" +
          //     pointUrl +
          //     "'/></div></div>",
          //   className: "ztgh-div-icon",
          //   iconAnchor: [16, 8]
          // });

          let baseLayer = L.marker([it.latitude_, it.longitude_], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.brandGroup);
          baseLayer.on("click", (e) => {
            e;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   e.sourceTarget.options.attributes
            // );
            // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
          baseLayer.on("mouseover", (it) => {
            console.log(
              "sourceTarget",
              it.sourceTarget.getElement().querySelector(".zhu-div-name")
                .classList
            );
            it.sourceTarget
              .getElement()
              .querySelector(".zhu-div-name")
              .classList.remove("hide");
          });
          baseLayer.on("mouseout", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhu-div-name")
              .classList.add("hide");
          });
        }
      });
      this.schjMap.addLayer(this.brandGroup);
    },

    loadFxl() {
      if (!this.overlay) {
        // eslint-disable-next-line no-undef
        this.overlay = new L.echartsLayer(this.schjMap, echarts);
        const chartsContainer = this.overlay.getEchartsContainer();
        this.myChart0 = this.overlay.initECharts(chartsContainer);
        // this.myChart0.un("click");
        this.myChart0.on("click", (val) => {
          //点击事件
          setTimeout(() => {
            this.$bus.$emit(
              "schjClick",
              "runPopup",
              val.name,
              val.value,
              val.data.id
            );
          }, 50);
        });
      }
      const option = initialize(); //这里跟百度echarts的map的option一样,the option is same as echarts map
      findDataSaleBydataKindIdAndYearAndProvinceCodeForMap({
        dataKindId: this.dataKindId,
        year: this.cMonth,
      }).then((res) => {
        let _data = [];
        let lineArr = [];
        res.data.map((v) => {
          let arr = [{ name: this.$config.zhwlCity }];
          const obj = {
            name: v.province_,
            value: Number(v.value),
            id: v.id,
            tooltip: {
              formatter: "{b}：{a}销售量{c}%",
            },
          };
          arr.push(obj);
          _data.push(obj);
          lineArr.push(arr);
        });
        console.log("markLine.data", lineArr);
        console.log("markPoint.data", _data);
        option.legend.data[0] = this.cName;
        option.series[1].name = this.cName;
        option.series[1].markPoint.data = _data;
        option.series[1].markLine.data = lineArr;
        this.overlay.setOption(option, true);
      });
      this.firstLoad = false;
      //   this.initEct();
    },
    reLoadFxl() {
      if (!this.overlay) {
        return;
      }
      this.overlay._ec.clear();
      this.loadFxl();
    },
    initEct() {
      // 加载echarts
      // echart title name change
      let _seriesName = "数量";
      let _ydata = []; // 名称
      let _sdata = [];
      let _ydata2 = []; // 名称
      let _sdata2 = [];
      findDataSaleBydataKindIdAndYear({
        dataKindId: this.dataKindId,
        year: this.cMonth,
        provinceCode: 44,
      }).then((res) => {
        if (res.data.length !== 0) {
          this.noChart1 = false;
          res.data.map((v) => {
            _ydata.push(v.name);
            _sdata.push(v.value);
          });
          this.setEchart(_ydata, _sdata, _seriesName, "吨");
        } else {
          this.noChart1 = true;
        }
        findDataSaleBydataKindIdAndYearAndProvinceCode({
          dataKindId: this.dataKindId,
          year: this.cMonth,
          provinceCode: 44,
        }).then((res) => {
          if (res.data.length !== 0) {
            this.noChart2 = false;
            res.data.map((v) => {
              _ydata2.push(v.name);
              _sdata2.push(v.value);
            });
          } else {
            this.noChart2 = true;
          }
          this.setEchart(_ydata, _ydata2, _sdata, _sdata2, _seriesName, "吨");
        });
      });
    },
    setEchart(_ydata, _ydata2, _sdata, _sdata2, _seriesName, unit) {
      let option1 = {
        color: ["#06d3cd"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function(val) {
            return val[0].name + ":" + val[0].value + unit;
          },
        },
        grid: {
          top: "3%",
          left: "left",
          right: "4%",
          bottom: 0,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: _ydata,
            axisLabel: {
              formatter: function(value) {
                return value.length > 6 ? value.slice(0, 6) + "..." : value;
              },
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              rotate: 45,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisTick: {
              inside: true,
            },
          },
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            inside: true,
          },
        },
        series: [
          {
            barWidth: "20",
            data: _sdata,
            name: _seriesName,
            type: "bar",
          },
        ],
      };
      this.echarts1.setOption(option1);
      const option2 = Object.assign({}, option1);
      option2.xAxis[0]["data"] = _ydata2;
      option2.series[0]["data"] = _sdata2;
      this.echarts2.setOption(option2);
    },
    getLat() {
      if (this.clatlng) {
        return this.clatlng;
      }
      return this.schjMap.getCenter();
    },
    runPopup(areaName = "xx", val = 66, id) {
      if (this.popup == null) {
        this.popup = L.popup({
          minWidth: 400,
          className: "jk-popup",
          autoPanPadding: L.point(200, 152),
          keepInView: true,
          offset: L.point(12, -32),
        });
      }
      const name = areaName + "地区" + this.cMonth + this.cName + "销量";
      if (id) {
        this.popup
          .setLatLng(this.getLat())
          .setContent(
            `<div class="titlePan">${name}</div>
            <div style="width: 400px; height: 300px;" id="popmarker-jk10086"></div>`
          )
          .openOn(this.schjMap);
        // echarts2
        setTimeout(() => {
          this.echarttu_marker("-jk10086", this.cName, val, id);
        }, 200);
      }
    },
    echarttu_marker(e, name, val, id) {
      findDataSaleByXSID({ id }).then((res) => {
        let date = [];
        let value = [];
        res.data.map((v) => {
          date.push(v.date);
          value.push(parseFloat(v.value).toFixed(2));
        });
        // 产量 demo
        const myChart2 = this.$echarts.init(
          document.getElementById("popmarker" + e)
        );

        let option = {
          title: {
            top: 6,
            left: 8,
            text: name + ":" + val + this.dw,
            textStyle: {
              fontSize: 14,
            },
          },
          grid: {
            left: "10%",
            top: "18%",
            right: "1%",
            bottom: "10%",
            // containLabel: true
          },
          tooltip: {
            trigger: "axis",
            formatter: "{b} <br/>{a} : {c} " + this.dw,
          },
          xAxis: [
            {
              type: "category",
              data: date,
              axisLine: {
                lineStyle: {
                  color: "#999",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              splitNumber: 4,
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "#DDD",
                },
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#333",
                },
              },
              nameTextStyle: {
                color: "#999",
              },
              splitArea: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: name + "",
              type: "line",
              data: value,
              lineStyle: {
                normal: {
                  width: 2,
                  color: {
                    type: "linear",

                    colorStops: [
                      {
                        offset: 0,
                        color: "#A9F387", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#48D8BF", // 100% 处的颜色
                      },
                    ],
                    globalCoord: false, // 缺省为 false
                  },
                  shadowColor: "rgba(72,216,191, 0.3)",
                  shadowBlur: 10,
                  shadowOffsetY: 20,
                },
              },
              itemStyle: {
                normal: {
                  color: "#fff",
                  borderWidth: 4,
                  /*shadowColor: 'rgba(72,216,191, 0.3)',
                  shadowBlur: 100,*/
                  borderColor: "#A9F387",
                },
              },
              smooth: true,
            },
          ],
        };
        myChart2.setOption(option);
      });
    },
    chartResize() {
      debounce(() => {
        this.echarts && this.echarts.resize();
      }, 300)();
    },
    location() {
      if (this.ismmsMap) {
        this.init();
      } else {
        this.schjMap.setView(L.latLng(38.44491421192701, 104.150390625), 4);
      }
    },
    tomms() {
      //   if (this.overlay) {
      //     // 清空流向
      //     this.overlay._ec.clear();
      //     const option = initialize();
      //     let _data = [];
      //     let lineArr = [];
      //     option.legend.data[0] = this.cName;
      //     option.series[1].name = this.cName;
      //     option.series[1].markPoint.data = _data;
      //     option.series[1].markLine.data = lineArr;
      //     this.overlay.setOption(option, true);
      //   }
      //   this.schjMap.setView(L.latLng(22.06082352547305, 110.97976684570312), 10);
      this.clearLayer(); //清空图层
      this.goMmsMap();
      this.ismmsMap = true;
      this.schjMap.setView(L.latLng(22.03118528348074, 110.81697802523058), 0);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styl/largeScreen/schj'
@import '~styl/smallScreen/schj'

.schjMap
    >>>
        .zhu-div-icon
            color #fff
        .indicator-box
            position relative
        .indicator-box:hover
            z-index 1000
        .zhu-div-text
            position absolute
            // height 30px
            // display flex
            // justify-content center
            // align-items center
            min-width 0.72rem
            border 1px #fff solid
            border-radius 5px
            padding 2px 10px
            white-space nowrap
        .sLine
            transform translate(28%, -67%)
        .zhu-div-box
            width 10px
            height 10px
            display flex
            justify-content center
            align-items center
            flex-wrap wrap
        .zhu-div-image
            width 31px
        .zhu-div-name
            // top -30px
            top 0
            transform translateY(-100%)
            text-align center
        .hide
            display none
        .zhus-div-name
            z-index 9
            font-size 0.09rem
            // border 1px #fff solid
            // border-radius 5px
            // padding 2px 10px
            // white-space nowrap
        .zhus-div-info
            z-index 9
            font-size 0.07rem
            color #fed926
        .yellow
            background-color rgba(0, 126, 120, 0.8)
        .ztgh-div-icon
            color #fff
            z-index 970 !important
        .indicator-box
            position relative
        .ztgh-div-image
            position relative
            width 0.1rem
            height 0.1rem
        .ico_sf
            width 0.11rem
            height 0.11rem
        .ztgh-div-text
            position absolute
            width 1.3rem
            height 30px
            display flex
            justify-content center
            align-items center
        .sLine
            transform translate(-110%, -50%)
        .ztgh-div-image
            position relative
            width 0.1rem
            height 0.1rem
        .nopx-point-y
          width 6px
          height 6px
          border-radius 50%
          background #f3d013
        .btm-zb
            position absolute
            left 28%
            bottom 3vh
            cursor pointer
            z-index 401
</style>
